/**
 * Screenshot system - F2 to capture, shows toast notification
 */
export class Screenshot {
  constructor(renderer) {
    this.renderer = renderer;
    this._toast = null;
    this._toastTimer = 0;
    this._build();

    document.addEventListener('keydown', (e) => {
      if (e.code === 'F2') {
        e.preventDefault();
        this.capture();
      }
    });
  }

  _build() {
    this._toast = document.createElement('div');
    this._toast.style.cssText = `
      position: fixed; bottom: 60px; left: 50%;
      transform: translateX(-50%);
      background: rgba(0,0,0,0.75);
      color: #aaffaa;
      font-family: 'Courier New', monospace;
      font-size: 13px;
      padding: 8px 16px;
      border: 2px solid #4a4a4a;
      z-index: 600;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.3s;
      image-rendering: pixelated;
    `;
    document.body.appendChild(this._toast);
  }

  capture() {
    try {
      const canvas = this.renderer.domElement;
      const dataUrl = canvas.toDataURL('image/png');

      // Create download link
      const link = document.createElement('a');
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      link.download = `fedeworld-${timestamp}.png`;
      link.href = dataUrl;
      link.click();

      this._showToast('Captura guardada!');
    } catch (err) {
      this._showToast('Error al capturar');
    }
  }

  _showToast(msg) {
    this._toast.textContent = msg;
    this._toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => {
      this._toast.style.opacity = '0';
    }, 2500);
  }
}
